import { render } from "./BundleItems.vue?vue&type=template&id=7cf63608&scoped=true"
import script from "./BundleItems.vue?vue&type=script&lang=js"
export * from "./BundleItems.vue?vue&type=script&lang=js"

import "./BundleItems.vue?vue&type=style&index=0&id=7cf63608&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf63608"]])

export default __exports__